var

    /**
     *
     * @param popupWidth {Number}
     * @param popupHeight {Number}
     * @returns {{left: Number, top: Number}}
     */
    getTopLeftForCenterWindow = function(popupWidth, popupHeight) {
        var width, height, left, top;
        // Fixes dual-screen position                                     Most browsers      Firefox
        var dualScreenLeft = (typeof window.screenLeft !== 'undefined') ? window.screenLeft : screen.left;
        var dualScreenTop = (typeof window.screenTop !== 'undefined') ? window.screenTop : screen.top;

        width = window.innerWidth ?
            window.innerWidth :
            document.documentElement.clientWidth ?
                document.documentElement.clientWidth :
                screen.width;
        height = window.innerHeight ?
            window.innerHeight :
            document.documentElement.clientHeight ?
                document.documentElement.clientHeight :
                screen.height;

        left = ((width / 2) - (popupWidth / 2)) + dualScreenLeft;
        top = ((height / 2) - (popupHeight / 2)) + dualScreenTop;

        return {left: left, top: top};

    },
    /**
     *
     * @param objectProperties {{
     *      menubar: String | undefined,
     *      location: String | undefined,
     *      resizable: String | undefined,
     *      scrollbars: String | undefined,
     *      status: String | undefined,
     *      width: Number | undefined,
     *      height: Number | undefined,
     *      top: Number | undefined,
     *      left: Number | undefined
     * }}
     * @returns {String}
     */
    convertObjectToWindowFeatures = function (objectProperties) {
        var properties = [];
        for (var property in objectProperties) {
            if (objectProperties.hasOwnProperty(property)) {
                properties.push(property + '=' + objectProperties[property]);
            }
        }
        return properties.join(",");
    },
    /**
     *
     * @param strUrl {String}
     * @param strWindowName {String} // (no spaces in string)
     * @param strWindowFeatures {=String} // (no spaces in string)
     * @returns {Window}
     */
    openWindow = function (strUrl, strWindowName, strWindowFeatures) {
        if (strWindowFeatures && strWindowFeatures !== null && strWindowFeatures.toString().length) {
            return window.open(strUrl, strWindowName, strWindowFeatures);
        } else {
            return window.open(strUrl, strWindowName);
        }

    },
    /**
     *
     * @param strUrl {String}
     * @param strWindowName {String} // (no spaces in string)
     * @param objectProperties {{
     *      menubar: String | undefined,
     *      location: String | undefined,
     *      resizable: String | undefined,
     *      scrollbars: String | undefined,
     *      status: String | undefined,
     *      width: Number | undefined,
     *      height: Number | undefined,
     *      top: Number | undefined,
     *      left: Number | undefined
     * }}
     * @returns {Window}
     */
    newWindow = function (strUrl, strWindowName, objectProperties) {
        return openWindow(strUrl, strWindowName, convertObjectToWindowFeatures(objectProperties));
    }
    ;
/**
 * @class diy.util.popupWindow
 * @template diy.util.popupWindow
 * @lends {diy.util.popupWindow.prototype}
 * @constructor
 */
module.exports = {
    getTopLeftForCenterWindow: getTopLeftForCenterWindow,
    convertToFeatures: convertObjectToWindowFeatures,
    open: openWindow,
    newWindow: newWindow
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/util/popupWindow.js
 ** module id = 737
 ** module chunks = 0
 **/